<template>
    <div class="appointments-created">
        <div class="appointments-created__title">
            <div class="appointments-created__icon">
                <CheckStatus class-name="icon-stroke icon_color_blue" />
            </div>
            Запись успешно {{ isAfterUpdate ? 'перенесена' : 'создана' }}
        </div>
        <div class="appointments-created__info">
            <div v-if="recordDate"
                 class="appointments-created__info-title">
                {{ recordDate }}
            </div>

            <div v-if="complexName || address"
                 class="appointments-created__info-project">
                <div v-if="complexName"
                     class="appointments-created__info-project-name">
                    {{ complexName }}
                </div>
                <div v-if="address"
                     class="appointments-created__info-project-dot">
                    •
                </div>
                <div v-if="address"
                     class="appointments-created__info-project-address">
                    {{ address }}
                </div>
            </div>

            <div v-if="clientPhone || comment || clientName"
                 class="appointments-created__info-client">
                <div v-if="clientPhone"
                     class="appointments-created__info-client-description">
                    {{ clientPhone }}
                </div>
                <!--                <div v-if="clientName"-->
                <!--                     class="appointments-created__info-project-dot">-->
                <!--                    •-->
                <!--                </div>-->
                <!--                <div v-if="clientName"-->
                <!--                     class="appointments-created__info-client-comment">-->
                <!--                    {{ clientName }} {{ clientSurname }}-->
                <!--                </div>-->
                <div v-if="comment"
                     class="appointments-created__info-project-dot">
                    •
                </div>
                <div v-if="comment"
                     class="appointments-created__info-client-comment">
                    {{ comment }}
                </div>
            </div>
        </div>

        <div class="appointments-created__footer">
            <STBaseButton v-if="!isAfterUpdate"
                          text="Записаться ещё"
                          modify="button_theme_white button_size_small"
                          @click="restartCreating" />

            <STBaseButton text="Смотреть записи"
                          icon-after="IconRightFill"
                          icon-after-modify="icon-fill icon_color_white"
                          modify="button_size_small"
                          @click="goToAppointments" />
        </div>
    </div>
</template>

<script>
import CheckStatus from '@/components/Icons/CheckStatus';
import {mapActions, mapGetters} from 'vuex';

export default {
    name: 'AppointmentsCreated',

    components: {
        CheckStatus
    },

    props: {
        recordDate   : String,
        projectId    : String,
        clientPhone  : String,
        clientName   : String,
        clientSurname: String,
        comment      : String,
        isAfterUpdate: {
            type   : [Boolean],
            default: false
        },
    },

    data() {
        return {
            complexName: null,
            address    : null
        };
    },

    computed: {
        ...mapGetters({
            complexes: 'GET_DISTRICT_LIST'
        }),
    },

    async mounted() {
        await this.getComplexData();
    },

    methods: {
        ...mapActions(['getComplexes']),

        async getComplexData() {
            if (!this.complexes?.length) {
                try {
                    await this.getComplexes();
                } catch (error) {
                    console.error('Произошла ошибка при запросе комплексов', JSON.stringify(error));
                    return;
                }
            }

            if (!this.complexes?.length) {
                console.error('Комплексы отсутствуют');
                return;
            }

            const complex = this.complexes.find((complex) => complex.id?.toLowerCase() === this.projectId.toLowerCase());

            if (!complex) {
                console.error('Комплекс не найден');
                return;
            }

            this.complexName = complex.name;
            this.address = complex.broker_address;
        },

        restartCreating() {
            this.$emit('restartCreating');
        },

        goToAppointments() {
            this.$emit('goToAppointments');
        }
    }
};
</script>

<style lang="scss">
@import "AppointmentsCreated";
</style>
